import { ReactElement } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { ClickAwayListener, Paper, Popper } from '@mui/material';

// project import
import { MainCard, Transitions } from '@trendiolive/trendio-selfcare-ui-kit';

// ==============================|| PROFILE - MENU POPPER ||============================== //

type MenuPopperProps = Readonly<{
  open: boolean;
  anchorRef: React.MutableRefObject<any>;
  onClose: (event: MouseEvent | TouchEvent) => void;
  children: ReactElement;
}>;

export default function MenuPopper({ open, anchorRef, onClose, children }: MenuPopperProps) {
  const theme = useTheme();

  return (
    <Popper
      placement="bottom-end"
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      popperOptions={{
        modifiers: [{ name: 'offset', options: { offset: [0, 9] } }]
      }}
    >
      {({ TransitionProps }) => (
        <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
          <Paper sx={{ boxShadow: theme.customShadows.z1, width: 290, minWidth: 240, maxWidth: { xs: 250, md: 290 } }}>
            <ClickAwayListener onClickAway={onClose}>
              <MainCard elevation={0} border={false} content={false}>
                {children}
              </MainCard>
            </ClickAwayListener>
          </Paper>
        </Transitions>
      )}
    </Popper>
  );
}
